import React, { useState } from "react";
import styles from "../css/styles.module.css";

export default function AddCustomer(props) {
  const [customer, setCustomer] = useState(() => {
    return {
      name: "",
      address: "",
      phone: "",
      website: "",
    };
  });

  //handle text change for input field
  function handleChange(e) {
    setCustomer({
      ...customer,
      [e.target.name]: e.target.value,
    });
  }

  return (
    <div className={styles.form}>
      <form
        onSubmit={() => {
          props.handleAddSubmit(customer);
        }}
      >
        <h1>Add Customer</h1>
        <input
          type="text"
          name="name"
          placeholder="Name"
          onChange={handleChange}
          value={customer.name}
          required
        />
        <input
          type="text"
          name="address"
          placeholder="Address"
          onChange={handleChange}
          value={customer.address}
        />
        <input
          type="text"
          name="phone"
          placeholder="Phone Number"
          onChange={handleChange}
          value={customer.phone}
        />
        <input
          type="text"
          name="website"
          placeholder="Website"
          onChange={handleChange}
          value={customer.website}
        />
        <button type="submit">Add</button>
      </form>
      <button
        className={styles.cancelButton}
        onClick={() => props.handleCancelClick()}
      >
        Cancel
      </button>
    </div>
  );
}
